import { CommandsGroupInterface, CommandsPageInterface } from '@nts/std/interfaces';
import { BaseCommandItem } from './base-command-item';

export class CommandsPage extends BaseCommandItem implements CommandsPageInterface {
    commandGroups: Array<CommandsGroupInterface> = new Array<CommandsGroupInterface>();

    constructor(name: string, displayName: string, keyTip: string) {
        super();

        this.name = name;
        this.displayName = displayName;
        this.keyTip = keyTip;
    }

    removeEmptyGroups() {
        const cmds = this.commandGroups.filter(g => g.commands.length > 0);
        this.commandGroups = new Array<CommandsGroupInterface>();
        this.commandGroups.push(...cmds);
    }

    addBefore(commandGroupName: string, group: CommandsGroupInterface) {
        this.commandGroups.splice(this.commandGroups.findIndex(commandsGroup => commandsGroup.name === commandGroupName), 0, group);
    }

    addAfter(commandGroupName: string, group: CommandsGroupInterface) {
        this.commandGroups.splice(this.commandGroups.findIndex(commandsGroup => commandsGroup.name === commandGroupName) + 1, 0, group);
    }

    addGroup(group: CommandsGroupInterface, checkIfEmpty = false) {
        const item = this.commandGroups.find(commandsGroup => commandsGroup.name === group.name);
        if (item == null) {
            if (!checkIfEmpty || group.commands.length > 0) {
                this.commandGroups.push(group);
            }
        }
    }
}
